import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "material-link-title flex-container-col" }
const _hoisted_3 = { class: "k-font-weight-bold" }
const _hoisted_4 = { class: "text-cutoff max100p" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_doc_icon = _resolveComponent("doc-icon")!
  const _component_material_picture = _resolveComponent("material-picture")!

  return (_openBlock(), _createElementBlock("div", {
    title: _ctx.infoText,
    class: "flex-container-col align-center material-link-container hover-lift",
    style: _normalizeStyle([{"position":"relative"}, _ctx.containerStyle]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["prevent"]))
  }, [
    _createVNode(_component_doc_icon, {
      "material-data": _ctx.materialData,
      style: {"position":"absolute","top":"10px","left":"10px"}
    }, null, 8, ["material-data"]),
    _createElementVNode("div", {
      class: _normalizeClass(["material-link", _ctx.materialLinkClass])
    }, [
      _createVNode(_component_material_picture, {
        "lazy-load": _ctx.lazyLoad,
        "material-data": _ctx.materialData,
        "with-zoom": false,
        "with-border": false
      }, null, 8, ["lazy-load", "material-data"])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.materialNo), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.materialText), 1)
    ])
  ], 12, _hoisted_1))
}